



















































































import BidButton from '@/components/buttons/BidButton.vue'
import EditButton from '@/components/buttons/EditButton.vue'
import { useDataTable } from '@/components/composables/useDataTable'
import type { Header } from '@/components/composables/useDataTable/types'
import PublishedTenderService from '@/services/publishedTender'
import { formatDate, formatEvaluationTime } from '@/utils/helpers'
import { defineComponent, reactive } from '@vue/composition-api'
import { UserRoles } from '@/enums/UserRoles'

export default defineComponent({
  setup({ type }) {
    const searchParams = reactive({ type })
    const { items, totalRecords, loading, pagination, search, query, pages, fetchData } = useDataTable(
      PublishedTenderService,
      searchParams,
    )

    return {
      items,
      totalRecords,
      loading,
      pagination,
      search,
      query,
      pages,
      fetchData,
      formatDate,
      formatEvaluationTime,
      PublishedTenderService,
    }
  },
  props: { type: { type: String, default: '' } },
  name: 'PublishedTendersList',
  components: { EditButton, BidButton },
  computed: {
    headers(): Array<Header> {
      return [
        { value: 'name', text: this.$t('tenderName'), sortable: true },
        { value: 'publishDate', text: this.$t('publishDate'), sortable: true },
        { value: 'endDate', text: this.$t('closureDate'), sortable: true },
        { value: 'offerValidityMinutes', text: this.$t('evaluationDuration'), sortable: true },
        { value: 'actions', text: this.$t('actions'), sortable: false, align: 'end' },
      ]
    },
    pageTitle(): string {
      if (this.type === 'buy') return String(this.$t('publishedTenders.buying'))
      if (this.type === 'sell') return String(this.$t('publishedTenders.selling'))
      return String(this.$t('publishedTenders.label'))
    },
    redirectedFrom(): string {
      return this.type === 'sell' ? 'PublishedSellingTenders' : this.type === 'buy' ? 'PublishedBuyingTenders' : ''
    },
    loggedInRole(): UserRoles {
      return this.$store.getters?.role
    },
    canMakeOffer(): boolean {
      return [UserRoles.client].includes(this.loggedInRole as UserRoles)
    },
  },
})
